// Copyright 2023, Alexander Nekrasov, All rights reserved.

export async function GetEthers() {
  const { ethers } = await import(/* webpackChunkName: "ethers" */ "ethers");
  return ethers;
}
